var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _ThemeAlert_instances, handleThemeAlertOpen_fn;
import { C as Component } from "./component-cLJ9vlHA.js";
import { C as CustomEvents } from "./events-DeC3n8dp.js";
import { o as onAnimationEnd } from "./utilities-2Suih3Nm.js";
import "./critical-Da0Dmhh9.js";
class ThemeAlert extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ThemeAlert_instances);
    __publicField(this, "requiredRefs", ["themeAlertMessage", "dialog"]);
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CustomEvents.themeAlertOpen, __privateMethod(this, _ThemeAlert_instances, handleThemeAlertOpen_fn).bind(this));
    if (this.hasAttribute("open")) {
      const state = this.getAttribute("data-state") || "error";
      this.openThemeAlert(state);
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CustomEvents.themeAlertOpen, __privateMethod(this, _ThemeAlert_instances, handleThemeAlertOpen_fn).bind(this));
  }
  openThemeAlert(state = "error") {
    const { dialog } = this.refs;
    const snackbar = dialog.querySelector(".snackbar");
    if (snackbar) {
      snackbar.classList.remove("snackbar--success", "snackbar--error", "snackbar--warning", "snackbar--info");
      snackbar.classList.add(`snackbar--${state}`);
    }
    dialog.showPopover();
    dialog.classList.add("opening");
    setTimeout(async () => {
      dialog.classList.remove("opening");
      dialog.classList.add("closing");
      await onAnimationEnd(dialog, void 0, {
        subtree: false
      });
      dialog.hidePopover();
      dialog.classList.remove("closing");
    }, 4e3);
  }
}
_ThemeAlert_instances = new WeakSet();
handleThemeAlertOpen_fn = function(event) {
  const { dialog, themeAlertMessage } = this.refs;
  const { text, state = "error" } = event.detail;
  if (!text) return;
  themeAlertMessage.textContent = text;
  const snackbar = dialog.querySelector(".snackbar");
  if (snackbar) {
    snackbar.classList.remove("snackbar--success", "snackbar--error", "snackbar--warning", "snackbar--info");
    snackbar.classList.add(`snackbar--${state}`);
  }
  dialog.showPopover();
  dialog.classList.add("opening");
  setTimeout(async () => {
    dialog.classList.remove("opening");
    dialog.classList.add("closing");
    await onAnimationEnd(dialog, void 0, {
      subtree: false
    });
    dialog.hidePopover();
    dialog.classList.remove("closing");
  }, 4e3);
};
if (!customElements.get("theme-alert")) {
  customElements.define("theme-alert", ThemeAlert);
}
